var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1536 167.009 33.0493 137.155 33.0493 100.347C33.0493 63.539 63.1536 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61489,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51221 117.65C7.5667 117.65 8.42153 116.795 8.42153 115.741C8.42153 114.686 7.5667 113.831 6.51221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5317 22.4227C75.5862 22.4227 76.4411 21.5679 76.4411 20.5134C76.4411 19.4589 75.5862 18.6041 74.5317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5947 118.924 17.6492C118.924 18.7037 119.779 19.5585 120.833 19.5585",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.472 30.0597M162.599 20.7518L162.599 8.57985M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.021 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.635 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 147.5L61.5 145.5L67.5 159.5L61.5 162L59 160.5L55 151V149L57 147.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 51L41.5 50.5C36.3 50.9 34.3333 55 34 57L33.5 110.5V134L36 137L39 139.5H59L59.5 136L61 134L64.5 132L77 126.5L97 117.5L103 113.5L109 107.5V59.5C109 53.1 104.333 51.1667 102 51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6553 167.921L83.3076 163.616L98.5675 157.356L106.393 168.703C107.567 170.79 110.306 174.67 105.219 178.485C101.463 181.302 97.9154 178.616 96.6111 176.92L91.9158 169.877L85.6553 167.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9546 133.081L81.736 124.316L98.1698 116.647C101.039 115.212 108.187 110.23 113.821 101.778C118.203 94.8916 120.081 92.1265 120.473 91.6048C122.168 89.7789 127.046 87.2225 132.994 91.6048C135.185 96.6132 147.993 123.69 154.123 136.602C155.427 139.471 156.001 145.836 147.862 148.34C142.854 147.714 133.255 146.775 129.081 146.384C126.472 146.254 120.16 146.462 115.777 148.34C113.328 149.39 105.549 153.015 97.3872 156.851C90.9463 159.878 84.2668 163.037 79.7796 165.166C77.4319 166.6 72.1105 168.217 69.6063 163.209C69.1235 162.243 68.5359 161.039 67.885 159.688C65.1605 154.03 61.3281 145.795 59.4331 141.689C58.3896 139.854 57.6332 135.564 62.9546 133.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.736 124.316L97.3872 156.851M60.9982 145.601L56.6077 147.797C55.1378 148.532 54.5328 150.312 55.2508 151.791L59.3551 160.241C60.0555 161.683 61.7661 162.319 63.2389 161.686L67.885 159.688M67.885 159.688C68.5359 161.039 69.1235 162.243 69.6063 163.209C72.1105 168.217 77.4319 166.6 79.7796 165.166C89.9529 160.34 111.395 150.219 115.777 148.34C120.16 146.462 126.472 146.254 129.081 146.384C133.255 146.775 142.854 147.714 147.862 148.34C156.001 145.836 155.427 139.471 154.123 136.602C147.993 123.69 135.185 96.6132 132.994 91.6048C127.046 87.2225 122.168 89.7789 120.473 91.6048C120.081 92.1265 118.203 94.8916 113.821 101.778C108.187 110.23 101.039 115.212 98.1698 116.647L62.9546 133.081C57.6332 135.564 58.3896 139.854 59.4331 141.689C61.3281 145.795 65.1605 154.03 67.885 159.688Z",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.395 124.863C154.292 122.169 156.889 115.206 154.196 109.309C151.503 103.412 144.539 100.814 138.642 103.508",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 163.26L84.8477 167.565L91.1082 169.521L95.8035 176.564C97.1078 178.26 100.655 180.946 104.412 178.129C109.498 174.314 106.759 170.434 105.586 168.347L97.7599 157",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3902 139.341H41C37.134 139.341 34 136.207 34 132.341V57.9117C34 54.0457 37.134 50.9117 41 50.9117H102.126C105.992 50.9117 109.126 54.0457 109.126 57.9117V97.8653",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.299,
    y: 37,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.254 71.3183L126.326 57.847C127.052 56.7693 128.597 56.6589 129.468 57.6223L132.126 60.5596C132.985 61.5087 134.501 61.4182 135.241 60.3738L143.061 49.3346C143.836 48.24 145.448 48.2039 146.271 49.2627L157.981 64.3183",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.072,
    cy: 47.1364,
    r: 3.13636,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 69H96",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 78H96",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2021 93.1572H61.0224",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2021 122H61.0224",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1797 93.1572H99.8538",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2021 102.506L99.8538 102.506",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 112H82",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7926 86.5852C54.3746 86.5852 51.1627 85.2534 48.7454 82.8398C46.3282 80.4262 45 77.2106 45 73.7926C45 70.3746 46.3319 67.1627 48.7454 64.7454C51.159 62.3282 54.3746 61 57.7926 61C61.2106 61 64.4226 62.3319 66.8398 64.7454C69.257 67.159 70.5852 70.3746 70.5852 73.7926C70.5852 77.2106 69.2534 80.4226 66.8398 82.8398C64.4262 85.257 61.2106 86.5852 57.7926 86.5852ZM57.7926 61.1472C54.4151 61.1472 51.2399 62.4643 48.8521 64.8521C46.4643 67.2399 45.1472 70.4151 45.1472 73.7926C45.1472 77.1701 46.4643 80.3453 48.8521 82.7331C51.2399 85.1209 54.4151 86.4381 57.7926 86.4381C61.1701 86.4381 64.3453 85.1209 66.7331 82.7331C69.1209 80.3453 70.4381 77.1701 70.4381 73.7926C70.4381 70.4151 69.1209 67.2399 66.7331 64.8521C64.3453 62.4643 61.1701 61.1472 57.7926 61.1472Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7926 83.2188C55.276 83.2188 52.9103 82.2401 51.1295 80.4594C49.3488 78.6787 48.3701 76.3129 48.3701 73.7964C48.3701 71.2798 49.3488 68.914 51.1295 67.1333C52.9103 65.3526 55.276 64.3739 57.7926 64.3739C60.3092 64.3739 62.6749 65.3526 64.4556 67.1333C66.2364 68.914 67.215 71.2798 67.215 73.7964C67.215 76.3129 66.2364 78.6787 64.4556 80.4594C62.6749 82.2401 60.3092 83.2188 57.7926 83.2188ZM57.7926 64.5137C55.3128 64.5137 52.9838 65.4777 51.2325 67.2326C49.4812 68.984 48.5136 71.3129 48.5136 73.7927C48.5136 76.2725 49.4776 78.6014 51.2325 80.3527C52.9838 82.104 55.3128 83.0716 57.7926 83.0716C60.2724 83.0716 62.6013 82.1077 64.3526 80.3527C66.1039 78.6014 67.0715 76.2725 67.0715 73.7927C67.0715 71.3129 66.1076 68.984 64.3526 67.2326C62.6013 65.4813 60.2724 64.5137 57.7926 64.5137Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7921 77.4461C55.7759 77.4461 54.1387 75.8089 54.1387 73.7927C54.1387 71.7765 55.7759 70.1392 57.7921 70.1392C59.8083 70.1392 61.4456 71.7765 61.4456 73.7927C61.4456 75.8089 59.8083 77.4461 57.7921 77.4461ZM57.7921 70.2864C55.8605 70.2864 54.2858 71.8611 54.2858 73.7927C54.2858 75.7243 55.8605 77.299 57.7921 77.299C59.7237 77.299 61.2984 75.7243 61.2984 73.7927C61.2984 71.8611 59.7237 70.2864 57.7921 70.2864Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.4442 76.0848C66.7319 76.0848 69.3971 73.4196 69.3971 70.1319C69.3971 66.8441 66.7319 64.1789 63.4442 64.1789C60.1564 64.1789 57.4912 66.8441 57.4912 70.1319C57.4912 73.4196 60.1564 76.0848 63.4442 76.0848Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7926 86.5852C54.3746 86.5852 51.1627 85.2534 48.7454 82.8398C46.3282 80.4262 45 77.2106 45 73.7926C45 70.3746 46.3319 67.1627 48.7454 64.7454C51.159 62.3282 54.3746 61 57.7926 61C61.2106 61 64.4226 62.3319 66.8398 64.7454C69.257 67.159 70.5852 70.3746 70.5852 73.7926C70.5852 77.2106 69.2534 80.4226 66.8398 82.8398C64.4262 85.257 61.2106 86.5852 57.7926 86.5852ZM57.7926 61.1472C54.4151 61.1472 51.2399 62.4643 48.8521 64.8521C46.4643 67.2399 45.1472 70.4151 45.1472 73.7926C45.1472 77.1701 46.4643 80.3453 48.8521 82.7331C51.2399 85.1209 54.4151 86.4381 57.7926 86.4381C61.1701 86.4381 64.3453 85.1209 66.7331 82.7331C69.1209 80.3453 70.4381 77.1701 70.4381 73.7926C70.4381 70.4151 69.1209 67.2399 66.7331 64.8521C64.3453 62.4643 61.1701 61.1472 57.7926 61.1472Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.3289 74.5358C46.5636 74.5358 45.8241 74.6388 45.1177 74.8302C45.1765 75.5403 45.2906 76.2319 45.4598 76.9052C46.0485 76.7213 46.6777 76.6219 47.3289 76.6219C50.7947 76.6219 53.6056 79.4329 53.6056 82.8987C53.6056 83.8553 53.3922 84.764 53.0059 85.5771C53.6498 85.8384 54.3231 86.0518 55.0148 86.2063C55.4526 85.1908 55.6954 84.076 55.6954 82.9023C55.6917 78.2813 51.9463 74.5358 47.3289 74.5358Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1122 65.1355C66.2255 64.1826 65.199 63.3658 64.0585 62.722C64.7575 63.4357 65.1917 64.4107 65.1917 65.4887C65.1917 67.6705 63.4256 69.4365 61.2439 69.4365C59.0621 69.4365 57.2961 67.6705 57.2961 65.4887C57.2961 63.3143 59.0511 61.552 61.2218 61.5409C60.1327 61.2356 58.9811 61.0737 57.7964 61.0737C57.6493 61.0737 57.5021 61.0773 57.3549 61.081C56.1371 62.159 55.3682 63.7337 55.3682 65.4887C55.3682 68.7375 57.9988 71.3681 61.2475 71.3681C64.4963 71.3681 67.1269 68.7375 67.1269 65.4887C67.1232 65.371 67.1159 65.2533 67.1122 65.1355Z",
    fill: "#194590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyUpdates);
export default __webpack_public_path__ + "static/media/company-updates.2cea8a84b8c5b0a1268dd8d38966d4a0.svg";
export { ForwardRef as ReactComponent };